export const container = {
  width: "100%",
  maxWidth: "100vw",
  minHeight: "100vh",
  height: "auto",
  background: 'linear-gradient(180deg, #1F8A8A 0%, #4FB6B2 25%, #9FE3DE 55%, #EAF7F6 85%, #F7FCFB 100%)',
  color: "#0F172A",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: "0",
  paddingBottom: "0",
  paddingLeft: "0",
  paddingRight: "0",
  overflow: "auto",
  position: "relative",
};

export const homeButton = {
  position: "absolute",
  top: "20px",
  left: "20px",
  padding: "8px 16px",
  borderRadius: "99px",
  background: "white",
  border: "2px solid #1AA39A",
  color: "#1AA39A",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "600",
  zIndex: 100,
  display: "flex",
  alignItems: "center",
  gap: "6px",
  transition: "all 0.2s ease",
};

export const statBox = {
  paddingTop: "8px",
  paddingBottom: "8px",
  paddingLeft: "12px",
  paddingRight: "12px",
  fontSize: "14px",
  borderRadius: "12px",
  background: "white",
  border: "1px solid rgba(15, 23, 42, 0.1)",
  color: "#0F172A",
};

export const card = {
  width: "100%",
  maxWidth: "380px",
  margin: "0 auto",
  paddingTop: "18px",
  paddingBottom: "18px",
  paddingLeft: "20px",
  paddingRight: "20px",
  borderRadius: "16px",
  backgroundColor: "#FFFFFF",
  border: "1px solid rgba(0, 0, 0, 0.05)",
  boxShadow: "0 6px 20px rgba(0, 0, 0, 0.04)",
  textAlign: "center",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  fontSize: "18px",
  minHeight: "56px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#0F172A",
};

export const button = {
  paddingTop: "14px",
  paddingBottom: "14px",
  paddingLeft: "24px",
  paddingRight: "24px",
  borderRadius: "16px",
  background: "#1AA39A",
  border: "none",
  color: "white",
  fontWeight: "600",
  fontSize: "16px",
  cursor: "pointer",
};

export const optionCard = (status) => ({
  paddingTop: "18px",
  paddingBottom: "18px",
  paddingLeft: "18px",
  paddingRight: "18px",
  fontSize: "16px",
  width: "100%",
  maxWidth: "380px",
  margin: "8px auto",
  cursor: "pointer",
  borderRadius: "16px",
  opacity: 1,
  transition: "all 0.2s ease",
  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.04)",
  backgroundColor:
    status === "correct"
      ? "#1AA39A"
      : status === "wrong"
        ? "#F0997B"
        : "#FFFFFF",
  border: status ? "3px solid white" : "1px solid rgba(0, 0, 0, 0.08)",
  textAlign: "center",
  color: status ? "white" : "#0F172A",
  fontWeight: "700"
});

export const imageOptionCard = (isSelected, feedbackState, isCorrectImage) => ({
  width: "100%",
  aspectRatio: "1 / 1",
  objectFit: "cover",
  borderRadius: "12px",
  border:
    (feedbackState === "wrong" && isCorrectImage)
      ? "4px solid #5DCAA5"
      : isSelected && feedbackState === "wrong"
        ? "4px solid #F0997B"
        : isSelected && feedbackState === "correct"
          ? "4px solid #5DCAA5"
          : isSelected
            ? "4px solid #185FA5"
            : "2px solid rgba(24, 95, 165, 0.1)",
  cursor: "pointer",
  opacity: feedbackState && !isSelected && !isCorrectImage ? 0.5 : 1,
});
